<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Use global element
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-global-element block="button" :locale="locale" v-model="element.object.global.enabled" @onGetValues="setGlobalValues" />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Anchor
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Text
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="text"
                            placeholder=""
                            v-model="element.object.values.text"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Href/Link
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="link"
                            placeholder=""
                            v-model="element.object.values.link"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Target
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.target.options" v-model="element.object.values.target" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Modal
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.modal.options" v-model="element.object.values.modal" />
                    </div>
                    <p class="text-xs mt-4 block text-right text-grey">This will overwrite Href and Target.</p>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Size
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.size.options" v-model="element.object.values.size" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Width
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.width.options" v-model="element.object.values.width" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Shape
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.shape.options" v-model="element.object.values.shape" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Text colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Text colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.colour" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Background colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Background colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.background" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Border colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Border colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.border" />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Hover
                </div>
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Text colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Text colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.hover_colour" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Background colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Background colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.hover_background" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Border colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Border colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.hover_border" />
                    </div>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import ColourField from '@/components/fields/inputs/Colour';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import TextField from '@/components/fields/inputs/Text';
    import SelectField from '@/components/fields/inputs/Select';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import GlobalField from '@/components/composer/Fields/Global';
    import GlobalMixin from '@/components/composer/Mixins/Global';

    export default {
        components: {
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-colour-field': ColourField,
            'app-field-text': TextField,
            'app-field-select': SelectField,
            'app-toggle-field': ToggleField,
            'app-global-element': GlobalField
        },

        mixins: [ GlobalMixin ],

        props: {
            element: {
                type: Object,
                required: true
            },
            locale: {
                required: false
            }
        },
        data: () => ({
            fields: {
                text: {
                    name: 'Text',
                    attribute: 'text'
                },
                size: {
                    name: 'Size',
                    attribute: 'size',
                    options: [
                        {
                            value: 'default',
                            label: 'Default'
                        },
                        {
                            value: 'sml',
                            label: 'Small'
                        },
                        {
                            value: 'md',
                            label: 'Medium'
                        },
                        {
                            value: 'lg',
                            label: 'Large'
                        },
                        {
                            value: 'xl',
                            label: 'Extra Large'
                        },
                    ]
                },
                width: {
                    name: 'Width',
                    attribute: 'width',
                    options: [
                        {
                            value: 'auto',
                            label: 'Auto'
                        },
                        {
                            value: 'full',
                            label: 'Full'
                        },
                    ]
                },
                shape: {
                    name: 'Shape',
                    attribute: 'shape',
                    options: [
                        {
                            value: 'pill',
                            label: 'Pill'
                        },
                        {
                            value: 'sqaure',
                            label: 'Sqaured'
                        },
                    ]
                },
                colour: {
                    name: 'Text Colour',
                    attribute: 'colour'
                },
                background: {
                    name: 'Background Colour',
                    attribute: 'background'
                },
                border: {
                    name: 'Border Colour',
                    attribute: 'border'
                },
                hover_colour: {
                    name: 'Text Colour',
                    attribute: 'hover_colour'
                },
                hover_background: {
                    name: 'Background Colour',
                    attribute: 'hover_background'
                },
                hover_border: {
                    name: 'Border Colour',
                    attribute: 'hover_border'
                },
                link: {
                    name: 'Href/Link',
                    attribute: 'link'
                },
                target: {
                    name: 'Target',
                    attribute: 'target',
                    options: [
                        {
                            value: '_blank',
                            label: 'New window'
                        },
                        {
                            value: '_self',
                            label: 'Same window'
                        }
                    ]
                },
                modal: {
                    name: 'Modal',
                    attribute: 'modal',
                    options: [
                        {
                            value: 'none',
                            label: 'None'
                        },
                        {
                            value: 'I want to',
                            label: 'I want to'
                        }
                    ]
                },
            }
        }),
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/ButtonSettings.vue